Object.defineProperty(exports, "__esModule", {
  value: !0
});
var React = require("react");
function _extends() {
  return (_extends = Object.assign || function (t) {
    for (var i = 1; i < arguments.length; i++) {
      var o = arguments[i];
      for (var s in o) {
        Object.prototype.hasOwnProperty.call(o, s) && (t[s] = o[s]);
      }
    }
    return t;
  }).apply(this, arguments);
}
var uncheckedIcon = React.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
      position: "absolute",
      top: 0
    }
  }, React.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
  })),
  checkedIcon = React.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
      position: "absolute",
      top: 0
    }
  }, React.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
  }));
function createBackgroundColor(t, i, o, s, n) {
  var e = (t - o) / (i - o);
  if (0 === e) return s;
  if (1 === e) return n;
  for (var h = "#", r = 1; r < 6; r += 2) {
    var a = parseInt(s.substr(r, 2), 16),
      c = parseInt(n.substr(r, 2), 16),
      l = Math.round((1 - e) * a + e * c).toString(16);
    1 === l.length && (l = "0" + l), h += l;
  }
  return h;
}
function convertShorthandColor(t) {
  if (7 === t.length) return t;
  for (var i = "#", o = 1; o < 4; o += 1) {
    i += t[o] + t[o];
  }
  return i;
}
function getBackgroundColor(t, i, o, s, n) {
  return createBackgroundColor(t, i, o, convertShorthandColor(s), convertShorthandColor(n));
}
function objectWithoutProperties(t, i) {
  var o = {};
  for (var s in t) {
    Object.prototype.hasOwnProperty.call(t, s) && -1 === i.indexOf(s) && (o[s] = t[s]);
  }
  return o;
}
var ReactSwitch = function (n) {
  function t(t) {
    n.call(this, t);
    var i = t.height,
      o = t.width,
      s = t.checked;
    this.t = t.handleDiameter || i - 2, this.i = Math.max(o - i, o - (i + this.t) / 2), this.o = Math.max(0, (i - this.t) / 2), this.state = {
      s: s ? this.i : this.o
    }, this.n = 0, this.e = 0, this.h = this.h.bind(this), this.r = this.r.bind(this), this.a = this.a.bind(this), this.c = this.c.bind(this), this.l = this.l.bind(this), this.u = this.u.bind(this), this.f = this.f.bind(this), this.p = this.p.bind(this), this.b = this.b.bind(this), this.g = this.g.bind(this), this.v = this.v.bind(this), this.w = this.w.bind(this);
  }
  return n && (t.__proto__ = n), ((t.prototype = Object.create(n && n.prototype)).constructor = t).prototype.componentDidUpdate = function (t) {
    t.checked !== this.props.checked && this.setState({
      s: this.props.checked ? this.i : this.o
    });
  }, t.prototype.k = function (t) {
    this.y.focus(), this.setState({
      C: t,
      M: !0,
      m: Date.now()
    });
  }, t.prototype.x = function (t) {
    var i = this.state,
      o = i.C,
      s = i.s,
      n = (this.props.checked ? this.i : this.o) + t - o;
    i.R || t === o || this.setState({
      R: !0
    });
    var e = Math.min(this.i, Math.max(this.o, n));
    e !== s && this.setState({
      s: e
    });
  }, t.prototype.S = function (t) {
    var i = this.state,
      o = i.s,
      s = i.R,
      n = i.m,
      e = this.props.checked,
      h = (this.i + this.o) / 2,
      r = Date.now() - n;
    !s || r < 250 ? this.T(t) : e ? h < o ? this.setState({
      s: this.i
    }) : this.T(t) : o < h ? this.setState({
      s: this.o
    }) : this.T(t), this.setState({
      R: !1,
      M: !1
    }), this.n = Date.now();
  }, t.prototype.h = function (t) {
    t.preventDefault(), "number" == typeof t.button && 0 !== t.button || (this.k(t.clientX), window.addEventListener("mousemove", this.r), window.addEventListener("mouseup", this.a));
  }, t.prototype.r = function (t) {
    t.preventDefault(), this.x(t.clientX);
  }, t.prototype.a = function (t) {
    this.S(t), window.removeEventListener("mousemove", this.r), window.removeEventListener("mouseup", this.a);
  }, t.prototype.c = function (t) {
    this.$ = null, this.k(t.touches[0].clientX);
  }, t.prototype.l = function (t) {
    this.x(t.touches[0].clientX);
  }, t.prototype.u = function (t) {
    t.preventDefault(), this.S(t);
  }, t.prototype.p = function (t) {
    50 < Date.now() - this.n && (this.T(t), 50 < Date.now() - this.e && this.setState({
      M: !1
    }));
  }, t.prototype.b = function () {
    this.e = Date.now();
  }, t.prototype.g = function () {
    this.setState({
      M: !0
    });
  }, t.prototype.v = function () {
    this.setState({
      M: !1
    });
  }, t.prototype.w = function (t) {
    this.y = t;
  }, t.prototype.f = function (t) {
    t.preventDefault(), this.y.focus(), this.T(t), this.setState({
      M: !1
    });
  }, t.prototype.T = function (t) {
    var i = this.props;
    (0, i.onChange)(!i.checked, t, i.id);
  }, t.prototype.render = function () {
    var t = this.props,
      i = t.disabled,
      o = t.className,
      s = t.offColor,
      n = t.onColor,
      e = t.offHandleColor,
      h = t.onHandleColor,
      r = t.checkedIcon,
      a = t.uncheckedIcon,
      c = t.boxShadow,
      l = t.activeBoxShadow,
      u = t.height,
      d = t.width,
      f = objectWithoutProperties(t, ["disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "boxShadow", "activeBoxShadow", "height", "width", "handleDiameter"]),
      p = this.state,
      b = p.s,
      g = p.R,
      v = p.M,
      w = {
        position: "relative",
        display: "inline-block",
        textAlign: "left",
        opacity: i ? .5 : 1,
        direction: "ltr",
        borderRadius: u / 2,
        WebkitTransition: "opacity 0.25s",
        MozTransition: "opacity 0.25s",
        transition: "opacity 0.25s",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none"
      },
      k = {
        height: u,
        width: d,
        margin: Math.max(0, (this.t - u) / 2),
        position: "relative",
        background: getBackgroundColor(b, this.i, this.o, s, n),
        borderRadius: u / 2,
        cursor: i ? "default" : "pointer",
        WebkitTransition: g ? null : "background 0.25s",
        MozTransition: g ? null : "background 0.25s",
        transition: g ? null : "background 0.25s"
      },
      y = {
        height: u,
        width: Math.min(1.5 * u, d - (this.t + u) / 2 + 1),
        position: "relative",
        opacity: (b - this.o) / (this.i - this.o),
        pointerEvents: "none",
        WebkitTransition: g ? null : "opacity 0.25s",
        MozTransition: g ? null : "opacity 0.25s",
        transition: g ? null : "opacity 0.25s"
      },
      C = {
        height: u,
        width: Math.min(1.5 * u, d - (this.t + u) / 2 + 1),
        position: "absolute",
        opacity: 1 - (b - this.o) / (this.i - this.o),
        right: 0,
        top: 0,
        pointerEvents: "none",
        WebkitTransition: g ? null : "opacity 0.25s",
        MozTransition: g ? null : "opacity 0.25s",
        transition: g ? null : "opacity 0.25s"
      },
      M = {
        height: this.t,
        width: this.t,
        background: getBackgroundColor(b, this.i, this.o, e, h),
        display: "inline-block",
        cursor: i ? "default" : "pointer",
        borderRadius: "50%",
        position: "absolute",
        transform: "translateX(" + b + "px)",
        top: Math.max(0, (u - this.t) / 2),
        outline: 0,
        boxShadow: v ? l : c,
        border: 0,
        WebkitTransition: g ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
        MozTransition: g ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
        transition: g ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
      };
    return React.createElement("div", {
      className: o,
      style: w
    }, React.createElement("div", {
      className: "react-switch-bg",
      style: k,
      onClick: i ? null : this.f,
      onMouseDown: function onMouseDown(t) {
        return t.preventDefault();
      }
    }, r && React.createElement("div", {
      style: y
    }, r), a && React.createElement("div", {
      style: C
    }, a)), React.createElement("div", {
      className: "react-switch-handle",
      style: M,
      onClick: function onClick(t) {
        return t.preventDefault();
      },
      onMouseDown: i ? null : this.h,
      onTouchStart: i ? null : this.c,
      onTouchMove: i ? null : this.l,
      onTouchEnd: i ? null : this.u,
      onTouchCancel: i ? null : this.v
    }), React.createElement("input", _extends({}, {
      type: "checkbox",
      role: "switch",
      disabled: i,
      style: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: 1
      }
    }, f, {
      ref: this.w,
      onFocus: this.g,
      onBlur: this.v,
      onKeyUp: this.b,
      onChange: this.p
    })));
  }, t;
}(React.Component);
ReactSwitch.defaultProps = {
  disabled: !1,
  offColor: "#888",
  onColor: "#080",
  offHandleColor: "#fff",
  onHandleColor: "#fff",
  uncheckedIcon: uncheckedIcon,
  checkedIcon: checkedIcon,
  boxShadow: null,
  activeBoxShadow: "0 0 2px 3px #3bf",
  height: 28,
  width: 56
}, exports.default = ReactSwitch;